import { useEffect, useState } from "react";
import { Alert, Button, Container, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { NavLink } from "react-router-dom";

import { IContainer } from "../../../types/container";

import { AppConfig } from "../../../config/appConfig";
import { useUserContext } from "../../../contexts/userContext";
import { ContainerService } from "../../../services/containerService";

import ContainerTable from "../../tables/containerTable";
import Navigation from "../../header";
import PermissionGate from "../../permissionGate";
import Spinner from "../../spinner";

import "../../../styles/entity/containerList.scss";

const ContainerList = () => {
	const userContext = useUserContext();
	const [gridView, setGridView] = useState<IContainer[]>();
	const [nameFilter, setNameFilter] = useState("");
	const [fillsPositionFilter, setFillsPositionFilter] = useState("All");
	const [statusFilter, setStatusFilter] = useState("true");
	const [isLoadingContainers, setIsLoadingContainers] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const loadContainerData = async () => {
		setIsLoadingContainers(true);
		setErrorMessage(undefined);

		ContainerService.getContainers()
			.then((response) => {
				console.log('ContainerService.getContainers: SUCCESS', response);
				let containers = ContainerService.mapContainers(response.data);
				setGridView(containers);
			})
			.catch((error) => {
				console.log('ContainerService.getContainers: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingContainers(false);
			});
	}

	useEffect(() => {
		loadContainerData();
	}, [])

	return (
		<div className="hwi-container-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageContainers}>
					<section className="hwi-entity-search-bar">
						<div className="search-header">
							<div className="title">Search Containers</div>
							<div><NavLink to="/container/add"><Button variant="outlined">New Container</Button></NavLink></div>
						</div>
						<section className="search-options">
							<FormControl size="small">
								<TextField
									label="Name"
									name="name"
									value={nameFilter}
									size="small"
									autoComplete="off"
									onChange={(event) => { setNameFilter(event.target.value) }}
								></TextField>
							</FormControl>
							<FormControl size="small">
								<InputLabel>Fills Position</InputLabel>
								<Select
									value={fillsPositionFilter}
									label="Fills Position"
									onChange={(event) => setFillsPositionFilter(event.target.value)}
								>
									<MenuItem value="All" key="0">All</MenuItem>
									<MenuItem value="true" key="1">Yes</MenuItem>
									<MenuItem value="false" key="2">No</MenuItem>
								</Select>
							</FormControl>
							<FormControl size="small">
								<InputLabel>Status</InputLabel>
								<Select
									value={statusFilter}
									label="Status"
									onChange={(event) => setStatusFilter(event.target.value)}
								>
									<MenuItem value="All" key="0">All</MenuItem>
									<MenuItem value="true" key="1">Active</MenuItem>
									<MenuItem value="false" key="2">Inactive</MenuItem>
								</Select>
							</FormControl>
						</section>
					</section>
					<Spinner dependency={isLoadingContainers} text="Loading Containers...">
						<section className="results">
							{errorMessage &&
								<Alert className="alert-error"
									severity="error">
									{errorMessage}
								</Alert>
							}
							{!errorMessage &&
								<ContainerTable data={gridView} name={nameFilter} fillsPosition={fillsPositionFilter} status={statusFilter}></ContainerTable>
							}
						</section>
					</Spinner>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default ContainerList;